import { Popup } from 'devextreme-react/popup'
import React, { FC, useEffect, useState } from 'react'
import { useRequestCache } from 'services'
import { AppStateType } from 'services/enums'
import appLogo from '../../../../public/icon_72.png'
import './loading-popup.scss'
import { Button } from 'devextreme-react'
import notify from 'devextreme/ui/notify'

type Props = {
    visible?: boolean
}

export const LoadingPopup: FC<Props> = ({ visible = true}) => {
    const [loadingMessage, setLoadingMessage] = useState<string>("Loading...")
    const [timeoutHasPassed, settimeoutHasPassed] = useState<boolean>(false)

    const { sendCacheAppState } = useRequestCache()

    const sendIssueReportAndNotify = async () => {
        await sendCacheAppState(AppStateType.MigrationIssue, "Migration issue.")

        if (navigator.onLine)
            notify('Issue report sent. Thank you!', 'success', 3000)

        else
            notify('It looks like you are offline, the issue will be sent when you come back online', 'info', 6000)
    }

    useEffect(() => {
        const timer = setTimeout(async () => {
            setLoadingMessage("It looks like there is an issue.")
            settimeoutHasPassed(true)
        }, 25000);
        return () => clearTimeout(timer);
      }, []);
    
    return (
        <Popup
            visible={visible}
            width={'100vw'}
            height={'100vh'}
            showCloseButton={false}
            title={'Update Available'}
            closeOnOutsideClick={false}
            showTitle={false}
            animation={undefined}
        >
            <div className={'loading-popup-container'}>
                <img src={appLogo} height='72px' width='auto' ></img>
                <div className={'loading-popup-heading'}>Load Manager</div>
                <div className={'loading-popup-content'}>{ loadingMessage }</div>
                {
                    timeoutHasPassed &&
                    <>
                        <Button
                            text="Send report"
                            onClick={async x => await sendIssueReportAndNotify()}
                        />
                    </>
                }
            </div>
        </Popup>
    )
}